/*==============================================================================
// File:        submissions.js
// Package:     Ruby on Rails / Mr Zen
// Synopsis:    Form Submission Controls
//============================================================================*/

document.addEventListener("DOMContentLoaded", function() {
    // Global variables.
    //
    var gloVar = {
        adError: "error",
        invalid: "invalid",
        zenError: "zen-error",
        isRequired: "is-required",
        zenRequire: "zen-required",
        zenCheckbx: ".js-check-confirm",
        subSection: ".zen-submission__section",
        // Standard JS selectors.
        //
        _body: document.getElementById("body"),
        _submitBtn: document.getElementById("submit-btn"),
        _termsCheck: document.getElementById("terms-confirm"),
        _submission: document.getElementById("zenSubmission"),
        _subCountry: document.getElementById("submission_country"),
        _formSubmission: document.getElementById("new_submission")
    };

    if (gloVar._submission !== null) {
        var defRequireMs = gloVar._submission.dataset.required_text,
            chkRequireMs = gloVar._submission.dataset.required_checkbox_text;
    }

    function sectionCheckboxes(section) {
        var _checkbox = section.querySelectorAll(gloVar.zenCheckbx);
        Array.prototype.forEach.call(_checkbox, function(input, response) {
            var _parent = input.parentNode;
            response = document.createElement("span");
            response.className = gloVar.zenError;
            response.innerHTML = chkRequireMs;
            if (input.checked === true) {
                removeClass(_parent, gloVar.isRequired);
                var required = _parent.querySelector("." + gloVar.zenError);
                if (required !== null) {
                    required.parentNode.removeChild(required);
                }
            }
            else {
                if (!hasClass(_parent, gloVar.isRequired)) {
                    addClass(_parent, gloVar.isRequired);
                    _parent.appendChild(response);
                }
            }
        });
    }

    if (gloVar._termsCheck !== null) {
        validateSubmitButton(gloVar._termsCheck, gloVar._submitBtn);
        gloVar._termsCheck.addEventListener("change", function() {
            validateSubmitButton(gloVar._termsCheck, gloVar._submitBtn);
        });
    }

    if (gloVar._subCountry !== null) {
        // Country select.
        //
        gloVar._subCountry.addEventListener("change", function() {
            var _countrySelVal = gloVar._subCountry.options[gloVar._subCountry.selectedIndex],
                _parent = gloVar._subCountry.parentNode;
            if (_countrySelVal.value.length > 0) {
                removeClass(gloVar._subCountry, gloVar.invalid);
                removeClass(gloVar._subCountry.parentNode, gloVar.isRequired);
                var _invalidContainer = _parent.querySelector("." + gloVar.zenError);
                if (_invalidContainer !== null) {
                    _invalidContainer.parentNode.removeChild(_invalidContainer);
                }
                if (gloVar._subCountry.closest(gloVar.subSection).querySelectorAll("." + gloVar.invalid).length === 0) {
                    removeClass(gloVar._subCountry.closest(gloVar.subSection), gloVar.adError);
                }
            }
            else {
                if (!hasClass(gloVar._subCountry, gloVar.invalid)) {
                    addClass(gloVar._subCountry, gloVar.invalid);
                }
            }
        });
    }

    if (gloVar._submission !== null) {
        var _formReqfields = gloVar._submission.querySelectorAll("." + gloVar.zenRequire);
        Array.prototype.forEach.call(_formReqfields, function (field) {
            var _parent = field.parentNode;
            var validate = function () {
                if (field.value.length > 0) {
                    removeClass(field, gloVar.invalid);
                    removeClass(_parent, gloVar.isRequired);
                    var _invalidContainer = _parent.querySelector("." + gloVar.zenError);
                    if (_invalidContainer !== null) {
                        _invalidContainer.parentNode.removeChild(_invalidContainer);
                    }
                    if (field.closest(gloVar.subSection).querySelectorAll("." + gloVar.invalid).length === 0) {
                        removeClass(field.closest(gloVar.subSection), gloVar.adError);
                    }
                } else {
                    if (!hasClass(field, gloVar.invalid)) {
                        addClass(field, gloVar.invalid);
                    }
                }
            };
            if (field.value.length > 0) {
                removeClass(field, gloVar.invalid);
                removeClass(_parent, gloVar.isRequired);
            }
            field.addEventListener('keyup', validate);
            field.addEventListener('change', validate);
        });
    }

    if (gloVar._formSubmission !== null) {
        // Prevent form validation.
        //
        gloVar._formSubmission.setAttribute("novalidate", true);
        // Manage form submission.
        //
        gloVar._submitBtn.addEventListener("click", function(element) {
            sectionCheckboxes(gloVar._submission)
            validateSubmitButton(gloVar._termsCheck, gloVar._submitBtn)
            var _errFound = gloVar._submission.querySelectorAll("." + gloVar.zenError),
                _s2invfields = document.querySelectorAll("." + gloVar.invalid);
            if (_s2invfields.length > 0 || _errFound.length > 0) {
                element.preventDefault();
                element.stopPropagation();
                Array.prototype.forEach.call(_s2invfields, function(field, response) {
                    var _parent = field.parentNode;
                    response = document.createElement("span");
                    response.className = gloVar.zenError;
                    response.innerHTML = defRequireMs;
                    if (!hasClass(_parent, gloVar.isRequired)) {
                        addClass(_parent, gloVar.isRequired);
                        _parent.appendChild(response);
                    }
                    if (!hasClass(field.closest(gloVar.subSection), gloVar.adError)) {
                        addClass(field.closest(gloVar.subSection), gloVar.adError);
                    }
                    document.querySelector("." + gloVar.adError).scrollIntoView({
                        behavior: "smooth"
                    });
                });
            }
            else {
                // Reset form validation.
                //
                gloVar._formSubmission.removeAttribute("novalidate");
                setTimeout(function(){
                    gloVar._formSubmission.submit();
                    gloVar._body.scrollIntoView({
                        behavior: "smooth"
                    });
                }, 200);
            }
        });
    }
});

/*------------------------------------------------------------------------------
// Class Management & Other Functions
//----------------------------------------------------------------------------*/

function validateSubmitButton(target, btn) {
    if (target.checked === true) {
        btn.removeAttribute("disabled");
    }
    else {
        setAttributes(btn, {
            "disabled": "disabled"
        });
    }
}

function setAttributes(el, attrs) {
    for(var key in attrs) {
        if(attrs.hasOwnProperty(key)) {
            el.setAttribute(key, attrs[key]);
        }
    }
}

var hasClass = function (el, cl) {
    var regex = new RegExp("(?:\\s|^)" + cl + "(?:\\s|$)");
    return !!el.className.match(regex);
},
addClass = function (el, cl) {
    el.className += " " + cl;
},
removeClass = function (el, cl) {
    var regex = new RegExp("(?:\\s|^)" + cl + "(?:\\s|$)");
    el.className = el.className.replace(regex, " ");
},
toggleClass = function (el, cl) {
    return hasClass(el, cl) ? removeClass(el, cl) : addClass(el, cl);
};

/*------------------------------------------------------------------------------
// Polyfill
//----------------------------------------------------------------------------*/

if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
